import React,{Component} from 'react';
import './MyClientsLocation.css';
import NabarClient from '../Components/NabarClient/NabarClient';
import HeaderTool from '../Components/HeaderTool/HeaderTool';
import CreateClientLocation from '../Components/CreateClientLocation/CreateClientLocation';
import ClientsLocationEdit from '../Components/ClientsLocationEdit/ClientsLocationEdit';
import HandleRes from '../Components/HandleRes/HandleRes';


import plusicon from '../../../image/plusicon.svg'
import Loading from '../Components/Loading/Loading';

import iconlocationsm from '../../../image/iconlocationsm.svg'
import axios from 'axios'
import { LinkAPI } from '../../../API/API'
class MyClientsLocation extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data: [],
             isLoading:true,
            inRequest:false,
            loc_id: "",
            address_name: "",
            address_alias: "",
            coordinates: [],
            address_nameError: "",
            address_aliasError: "",
            res_done: false,
            res_doneEdit: false,
            networkError: false,
            res_donedelete:false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError:false,
        }
        this.savedlocations()
    }
    savedlocations = () => {
        const Token = localStorage.getItem("userToken")

        axios.get(`${LinkAPI}/api/businessowner/savedlocations`, {
            headers: {
                Authorization: `${Token}`,
                lang:"ar"
            }
        }).then(res => {
            this.setState({
                data: res.data.businessOwner.savedlocations.reverse(),
                isLoading:false,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError:false,
            })
        }).catch(error => {
            if (!error.response) {
                this.setState({
                    networkError: true
                })
            } else if (error.response.status === 402) {
                localStorage.setItem("userToken", '')
                window.location.replace("/SignIn");
            } else if (error.response.data.message) {
                this.setState({
                    errordatamessage: true,
                    errordatamessagetext:error.response.data.message
                })
            } else {
                this.setState({
                    hasError: true,
                })
            }
        })
    }
    handleChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    };
    setStateField = (object) => e => {
        this.setState({
            objectClient: object,
            loc_id: object._id,
            address_name: object.address_name,
            address_alias: object.address_alias,
            coordinates: object.location.coordinates,
            address_nameError: "",
            address_aliasError: "",
        })
    }
    setStatecoordinatesaddress_alias = (coordinates, address_name) => {
        this.setState({
            coordinates: coordinates,
            address_name: address_name

        })
    }

    handelpageCreateCilent = () => {
        this.setState({
            objectClient: null,
            loc_id: "",
            address_name: "",
            address_alias: "",
            coordinates: null,
        })
    }
    validateLocation = () => {
        let address_nameError = "";
        let address_aliasError = "";
        if (this.state.address_name.length < 4 || !isNaN(this.state.address_name)) {
            address_nameError = "اختار عنوان صحيحا";
        }
        if (this.state.address_alias.length < 4 || !isNaN(this.state.address_alias)) {
            address_aliasError = "ادخل تفاصيل العنوان";
        }
        if (this.state.coordinates.length < 1) {
            address_nameError = "اختار عنوان صحيحا";
        }
        if (address_nameError || address_aliasError) {
            this.setState({ address_nameError, address_aliasError });
            return false;
        }

        return true;
    };
    handleSubmitCreateLocation = event => {
        event.preventDefault();
        const { address_name, address_alias, coordinates } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validateLocation();
        if (isValid) {
            this.setState({ inRequest:true})

            // clear form
            axios.post(`${LinkAPI}/api/businessowner/addnewlocation`, {
                newlocation: {
                    address_name: address_name,
                    address_alias: address_alias,
                    location: {
                        coordinates: coordinates
                    }
                }
            }
                , {
                    headers: {
                        Authorization: `${Token}`,
                        lang:"ar"
                    }
                }
            ).then(res => {
                this.savedlocations()
                this.setState({
                    address_name: "",
                    address_alias: "",
                    coordinates: null,
                    address_nameError: "",
                    address_aliasError: "",
                    res_doneEdit: false,
                    res_done: true,
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError:false,
                })
                setTimeout(() => {
                    this.setState({
                        res_done:false,
                        inRequest:false

                    })
            }, 2000);
            }).catch(error => {
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                } else if (error.response.status === 402) {

                    window.location.replace("/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        errordatamessage: true,
                        errordatamessagetext:error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            
            })
        }
    };
    handleSubmitEditLocation = event => {
        event.preventDefault();
        const { address_name, address_alias, coordinates, loc_id } = this.state
        const Token = localStorage.getItem("userToken")
        const isValid = this.validateLocation();
        if (isValid) {
            this.setState({ inRequest:true})

            // clear form
            axios.put(`${LinkAPI}/api/businessowner/editlocation`, {
                location: {
                    address_name: address_name,
                    address_alias: address_alias,
                    location: {
                        coordinates: coordinates
                    }
                },
                loc_id: loc_id
            }
                , {
                    headers: {
                        Authorization: `${Token}`,
                        lang:"ar"
                    }
                }
            ).then(res => {
                this.savedlocations()
                this.setState({
                    loc_id: "",
                    address_name: "",
                    address_alias: "",
                    coordinates: [],
                    objectClient:null,
                    address_nameError: "",
                    address_aliasError: "",
                    res_done:false,
                    res_donedelete:false,
                    res_doneEdit: true,
                    networkError: false,
                    errordatamessage: false,
                    errordatamessagetext: '',
                    hasError:false,
                })
                setTimeout(() => {
                    this.setState({
                        res_doneEdit:false,
                        inRequest:false

                    })
            }, 2000);
            }).catch(error => {
                if (!error.response) {
                    this.setState({
                        networkError: true
                    })
                } else if (error.response.status === 402) {

                    window.location.replace("/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        errordatamessage: true,
                        errordatamessagetext:error.response.data.message
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
            })
        }
    };
    handleSubmitDeleteLocation = event => {
        event.preventDefault();
        const { loc_id } = this.state
        const Token = localStorage.getItem("userToken")
        this.setState({ inRequest:true})

        axios.delete(`${LinkAPI}/api/businessowner/deletelocation`, {
            data: { loc_id: loc_id },
            headers: {
                Authorization: `${Token}`,
                lang:"ar"
            }
        }
        ).then(res => {
            this.savedlocations()
            this.setState({
                loc_id: "",
                address_name: "",
                address_alias: "",
                coordinates: null,
                address_nameError: "",
                address_aliasError: "",
                res_donedelete:true,
                networkError: false,
                errordatamessage: false,
                errordatamessagetext: '',
                hasError:false,
            })
            setTimeout(() => {
                this.setState({
                    res_donedelete:false,
                    inRequest:false
                })
        }, 2000);

        }).catch(error => {
            if (!error.response) {
                this.setState({
                    networkError: true
                })
            } else if (error.response.status === 402) {
                localStorage.setItem("userToken", '')
                window.location.replace("/SignIn");
            } else if (error.response.data.message) {
                this.setState({
                    errordatamessage: true,
                    errordatamessagetext:error.response.data.message
                })
            } else {
                this.setState({
                    hasError: true,
                })
            }
        })
    }
    render(){
        document.title ="kayn | العناوين "; 
        document.getElementsByTagName("META")[1].content="كاين | العناوين  ";
        document.documentElement.lang = 'ar';
        return(
            <div>
                <div className="AppAR row  mx-0">
                    <div className="col-md-1 px-0 ">
                        <NabarClient />
                    </div>
                    <div className=" MyClients client col-md-11 px-lg-5">
                        <HeaderTool />
                    <div className="row ">
                    <h3 className=" col-12 fontsize9 my-0  order-8 order-md-2">العناوين</h3>

                            <div className="col-md-4 px-2 py-3  order-8 order-md-2">                                
                                <div className="tableDetails border shadow mx-auto">
                                    <div className="thead-light fontsize12 text-muted">
                                        <div className="headertable p-3 border">
                                            <p className="m-0">مرتبة حسب التاريخ</p>
                                        </div>
                                    </div>
                                    <div className="fontsize12">
            
                                        {
                                            (this.state.isLoading?<Loading/>:
                                                (this.state.data.length===0?<p className="  fontsize5 my-2 mx-auto text-center">لم تقوم بحفظ بيانات اي عنوان</p>:

                                            this.state.data.map((x, i) => (
                                                <div className={"py-2 border-bottom item-table pointer "+(this.state.loc_id===x._id?'active':'')} key={i} onClick={this.setStateField(x)}>
                                                    <a className="row m-0 p-1" ><img className=" p-0 col-2" src={iconlocationsm} alt="iconlocationsm" /><span className="px-0 pt-2 col-10">{x.address_name}</span></a>
                                                </div>))
                                        ))
                                        }
                                    </div>
                                </div>
                                {(this.state.objectClient ?
                                    <div className="createDiv p-2 text-center"><a onClick={this.handelpageCreateCilent}><button className="text-white badge-pill p-2 pl-1 px-4 border shadow bluebg text-center ">
                                        <img className="ml-2 " src={plusicon} alt="plusicon" />تسجيل</button>
                                    </a>
                                    </div>
                                    : ''
                                )}
                            </div>
                            <div className="col-md-8 px-4 py-3 order-5">
                            <div className="picbg">
                                    {(this.state.objectClient ?
                                        <ClientsLocationEdit state={this.state} handleSubmitDeleteLocation={this.handleSubmitDeleteLocation} handleSubmitEditLocation={this.handleSubmitEditLocation} handleChange={this.handleChange} setStatecoordinatesaddress_alias={this.setStatecoordinatesaddress_alias} />
                                        :
                                        <CreateClientLocation handleSubmitCreateLocation={this.handleSubmitCreateLocation} setStatecoordinatesaddress_alias={this.setStatecoordinatesaddress_alias} state={this.state} handleChange={this.handleChange} />
                                    )}
                                </div>
                            </div>
                            </div>
                    </div>
                </div>
                {(this.state.networkError ? <HandleRes title="تاكد باتصالك بالانترنت ثم عاود المحاوله" stylecss="alert-danger"/> : '')}
                {(this.state.res_doneEdit ? <HandleRes title="تم تعديل العنوان" stylecss="alert-success"/> : '')}
                {(this.state.res_donedelete ? <HandleRes title="تم حذف العنوان" stylecss="alert-success"/> : '')}

                {(this.state.res_done ? <HandleRes title="تم حفظ العنوان" stylecss="alert-success"/> : '')}
                {(this.state.errordatamessage ? <HandleRes title={this.state.errordatamessagetext} stylecss="alert-danger"/> : '')}
                {(this.state.hasError ? <HandleRes title="  هناك مشكلة في طلبك" stylecss="alert-danger"/> : '')}

            </div>
        )
    }
}
export default MyClientsLocation;